import { create } from '@storybook/theming/create';

export default create({
  base: 'dark',
  brandImage: '/images/storybook_logo_dark.png',
  brandTarget: '_self',
});